import { DICE_IVORY, DICE_PIP } from './world/rollPresentation'

const patterns:Record<number,number[][]>={2:[[4,4],[11,11]],3:[[4,4],[7.5,7.5],[11,11]],4:[[4,4],[11,4],[4,11],[11,11]],5:[[4,4],[11,4],[7.5,7.5],[4,11],[11,11]]}
function Pips({value,transform}:{value:number;transform:string}){
  return <g transform={transform} fill={DICE_PIP}>{patterns[value].map(([x,y],i)=><circle key={i} cx={x} cy={y} r="1.4"/>)}</g>
}
function Die({x,y,angle,top}:{x:number;y:number;angle:number;top:number}){
  return <g transform={`translate(${x} ${y}) rotate(${angle} 16 18)`}>
    <g strokeLinejoin="round" strokeWidth="2">
      <path d="M1 10 16 18 16 35 1 27Z" fill="#dfdccd" stroke="#dfdccd"/>
      <path d="M16 18 31 10 31 27 16 35Z" fill="#eee8d9" stroke="#eee8d9"/>
      <path d="M1 10 16 2 31 10 16 18Z" fill={DICE_IVORY} stroke={DICE_IVORY}/>
    </g>
    <Pips value={top} transform="matrix(1 .533 -1 .533 16 2)"/>
    <Pips value={top===3?2:4} transform="matrix(1 .533 0 1 1 10)"/>
    <Pips value={top===3?5:2} transform="matrix(1 -.533 0 1 16 18)"/>
  </g>
}
export function RollDiceIcon(){
  return <svg className="roll-dice-icon" width="74" height="36" viewBox="0 0 80 43" aria-hidden="true"><Die x={3} y={4} angle={-9} top={3}/><Die x={44} y={0} angle={10} top={5}/></svg>
}
